import {NgModule} from "@angular/core";
import {
	PreloadAllModules,
	RouterModule,
	Routes
} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {FeatureToggleService} from "@seniorsistemas/platform-components";

import {TracksaleService} from "./core/services/tracksale.service";
import {TourService} from "./core/utils/tour/tour.service";
import {AnalyticsTitleResolver} from "./shared/resolvers/router-title.resolve";
import {
	AnalyticsManagerUrlHCMResolver,
	HcmTenantConfigResolver,
	LocaleResolver,
	PersonActiveEmployeesResolver,
	RecruitmentPropertyIsUsingNewVacancyManagementResolver,
	UserDataResolver
} from "./shared/resolvers/router-utils.resolve";
import {PermissionsCanAccessRouter} from "./shared/utils/permissions-can-access.router";

const appRoutes: Routes = [
	{
		path: "",
		redirectTo: "analytics",
		pathMatch: "full",
		runGuardsAndResolvers: "always"
	},
	{
		path: "analytics",
		canActivate: [PermissionsCanAccessRouter],
		resolve: {
			activeEmployees: PersonActiveEmployeesResolver,
			localeService: LocaleResolver,
			hcmFrontendUrl: AnalyticsManagerUrlHCMResolver,
			hcmTenantConfig: HcmTenantConfigResolver,
			recruitment: RecruitmentPropertyIsUsingNewVacancyManagementResolver
		},
		data: {
			routeTitle: AnalyticsTitleResolver
		},
		children: [
			{
				path: "",
				redirectTo: "my",
				pathMatch: "full",
				runGuardsAndResolvers: "always"
			},
			{
				path: "",
				loadChildren: () => import('./modules/my-analytics/my-analytics.module').then(m => m.MyAnalyticsModule)
			},
			{
				path: "",
				loadChildren: () => import('./modules/team-analytics/team-analytics.module').then(m => m.TeamAnalyticsModule)
			},
			{
				path: "",
				loadChildren: () => import('./modules/led-analytics/led-analytics.module').then(m => m.LedAnalyticsModule)
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forRoot(appRoutes, {
		useHash: true,
		preloadingStrategy: PreloadAllModules
	})],
	exports: [RouterModule],
	providers: [
		PersonActiveEmployeesResolver,
		LocaleResolver,
		AnalyticsManagerUrlHCMResolver,
		HcmTenantConfigResolver,
		RecruitmentPropertyIsUsingNewVacancyManagementResolver,
		FeatureToggleService,
		TourService,
		TranslateService,
		TracksaleService,
		UserDataResolver
	]
})
export class AppRoutingModule {
}
